import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "svg-danger",
  "use": "svg-danger-usage",
  "viewBox": "0 0 32 32",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\" fill=\"none\" stroke=\"currentColor\" stroke-linejoin=\"round\" stroke-width=\"2\" id=\"svg-danger\"><path d=\"M5.35,27.89H26.65a2,2,0,0,0,1.76-2.95L17.76,5.16c-0.76-1.4-2.77-1.4-3.52,0L3.59,24.94A2,2,0,0,0,5.35,27.89Z\" /><path d=\"m15.64 12.21 0.36 7.63 0.36-7.62a0.36 0.36 0 0 0-0.36-0.36 0.36 0.36 0 0 0-0.36 0.35z\" /><path d=\"M16,24.83a1.25,1.25,0,1,1,1.25-1.25A1.25,1.25,0,0,1,16,24.83Z\" fill=\"currentColor\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol